// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';
import { addRemoveModalClass } from '../../shared/services/add-remove-modal-class';

export const updateDealerSearchModalVisibility = (isVisible) => (dispatch) => {

    addRemoveModalClass(!isVisible);

    dispatch({
        isVisible,
        type: actions.UPDATE_DEALER_SEARCH_MODAL_VISIBILITY,
    });

};
